import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import prReducer from './slices/prSlice';
import poReducer from './slices/poSlice';
import approvalReducer from './slices/approvalSlice';
import budgetReducer from './slices/budgetSlice';
import sapReducer from './slices/sapSlice';
import uiReducer from './slices/uiSlice';
import tabsReducer from './slices/tabStateSlice';
import scReducer from './slices/scSlice';
import paymentRequestReducer from './slices/paymentRequestSlice';
import salesReducer from './slices/salesSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        pr: prReducer,
        po: poReducer,
        approval: approvalReducer,
        budget: budgetReducer,
        sap: sapReducer,
        ui: uiReducer,
        tabs: tabsReducer,
        sc: scReducer,
        paymentRequest: paymentRequestReducer,
        sales: salesReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
